module.exports = __webpack_public_path__ + "static/media/upptic-logo-small.09436d4f.svg";